import React, { useEffect, useRef } from 'react';
import Button from '../ui/Button';
const Hero = () => {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const buttonsRef = useRef(null);
  useEffect(() => {
    const title = titleRef.current;
    const subtitle = subtitleRef.current;
    const buttons = buttonsRef.current;
    if (title && subtitle && buttons) {
      title.classList.add('animate-fadeInUp');
      setTimeout(() => {
        subtitle.classList.add('animate-fadeInUp');
      }, 300);
      setTimeout(() => {
        buttons.classList.add('animate-fadeInUp');
      }, 600);
    }
  }, []);
  return <section className="relative h-screen flex items-center" data-id="element-133">
      <div className="absolute inset-0 z-0" data-id="element-134">
        <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Construction site" className="w-full h-full object-cover" data-id="element-135" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40" data-id="element-136"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-137">
        <div className="max-w-3xl" data-id="element-138">
          <h1 ref={titleRef} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 opacity-0 transition-all duration-1000 translate-y-8" data-id="element-139">
            Building Tomorrow's Landmarks Today
          </h1>
          <p ref={subtitleRef} className="text-xl text-gray-200 mb-8 max-w-2xl opacity-0 transition-all duration-1000 translate-y-8" data-id="element-140">
            Socrates & Richard delivers excellence in Architectural (Building)
            Design, construction, civil works, and real estate — driven by
            innovation, precision, and integrity.
          </p>
          <div ref={buttonsRef} className="flex flex-wrap gap-4 opacity-0 transition-all duration-1000 translate-y-8" data-id="element-141">
            <Button to="/projects" variant="primary" size="lg" data-id="element-142">
              Explore Our Work
            </Button>
            <Button to="/contact" variant="outline" size="lg" data-id="element-143">
              Get In Touch
            </Button>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;